module.exports = __webpack_public_path__ + "img/loading.d157efb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.svg
// module id = nuJt
// module chunks = 0